import router from '@/router';
import store from '@/store/index';
import logout from '@/util/logout';
import { getExchangeRateList } from '@/api/Config';
import statusCode from '@/assets/constant/statusCode';
import { check_session_and_logout } from '@/util/session_check';

router.beforeEach(async (to, from, next) => {
	const token = window.sessionStorage.getItem('token');
	// 判斷是否從其他頁面跳轉過來
	if (to.redirectedFrom && to.redirectedFrom !== '/' && to.redirectedFrom !== '/login' && to.redirectedFrom !== '/dashboard') {
		localStorage.setItem('redirected', to.redirectedFrom);
	}
	// 判斷有要求權限的頁面檢查token
	if (token) {
		if (to.path === '/login') {
			// 進入登錄頁面
			if (store.getters.addRouters.length <= 0) {
				// 同步sessionStorage至vuex中
				await refershData();
				next('dashboard');
			} else {
				next('dashboard');
			}
		} else {
			// 正常流程
			if (store.getters.addRouters.length <= 0) {
				await refershData();
			}
			next();
		}
	} else if (to.path === '/') {
		window.sessionStorage.clear();
		next('login');
	} else {
		next();
	}
});

async function refershData() {
	try {
		// 檢查 sessionStorage 完整性，如果資料缺失則自動登出
		check_session_and_logout('refershData');

		store.dispatch('generateRoutes', JSON.parse(window.sessionStorage.getItem('router')));
		for (let i of store.getters.addRouters) {
			router.addRoute(i);
		}
		store.dispatch('setDomain', JSON.parse(window.sessionStorage.getItem('domain')));
		store.dispatch('setCms', JSON.parse(window.sessionStorage.getItem('cms')));
		store.dispatch('setGameList', JSON.parse(window.sessionStorage.getItem('gameList')));
		store.dispatch('setCurrencyList', JSON.parse(window.sessionStorage.getItem('currencyList')));
		const operator = JSON.parse(window.sessionStorage.getItem('operator'));
		store.dispatch('setOperator', operator);
		const exchangeRateList = await getExchangeRateList({
			reqData: { operatorID: parseInt(operator.operatorID) }
		});
		if (exchangeRateList.status === statusCode.STATUS_OK) {
			store.dispatch('setExchangeRate', JSON.parse(JSON.stringify(exchangeRateList.result.res)));
		}
	}
	catch (e) {
		logout();
	}
}
